module.exports = __webpack_public_path__ + "img/south-sudan.c05dcec9.png";